/* Bookly V80
   Sync qty mellom sticky add-to-cart bar og buybox.
   Viktig: Vi overstyrer ikke theme.js sin +/- logikk, vi synkroniserer kun input-verdier.
*/

(function () {
  try {
    if (!document.body) return;
    if (!document.body.classList.contains('template-product')) return;

    var stickyForm = document.querySelector('.pro_sticky_atc form#sticky_add_to_cart');
    var mainForm = document.querySelector('form#AddToCartForm');
    if (!stickyForm || !mainForm) return;

    var stickyQty = stickyForm.querySelector('input[name="quantity"]');
    var mainQty = mainForm.querySelector('input[name="quantity"]');
    if (!stickyQty || !mainQty) return;

    var syncing = false;

    function safeInt(val, fallback) {
      var n = parseInt(String(val || ''), 10);
      return isNaN(n) ? fallback : n;
    }

    function clampQty(n, inputEl) {
      var min = safeInt(inputEl.getAttribute('min'), 1);
      var max = safeInt(inputEl.getAttribute('max'), 9999);
      if (n < min) n = min;
      if (n > max) n = max;
      return n;
    }

    function setQty(target, value) {
      var next = clampQty(safeInt(value, 1), target);
      target.value = String(next);
    }

    function syncToMain() {
      if (syncing) return;
      syncing = true;
      setQty(mainQty, stickyQty.value);
      mainQty.dispatchEvent(new Event('change', { bubbles: true }));
      syncing = false;
    }

    function syncToSticky() {
      if (syncing) return;
      syncing = true;
      setQty(stickyQty, mainQty.value);
      syncing = false;
    }

    // Sticky -> Main
    stickyQty.addEventListener('input', syncToMain);
    stickyQty.addEventListener('change', syncToMain);
    stickyForm.addEventListener('click', function (e) {
      if (!e.target) return;
      if (e.target.closest('.inc_btn, .dec_btn')) {
        setTimeout(syncToMain, 0);
      }
    });

    // Main -> Sticky
    mainQty.addEventListener('input', syncToSticky);
    mainQty.addEventListener('change', syncToSticky);
    mainForm.addEventListener('click', function (e) {
      if (!e.target) return;
      if (e.target.closest('.inc_btn, .dec_btn')) {
        setTimeout(syncToSticky, 0);
      }
    });

    // Initial sync: behold main som source of truth
    syncToSticky();
  } catch (err) {
    // Silent fail: skal aldri knekke produktsiden
  }
})();
